import { call, put } from 'redux-saga/effects';
import { OffersAsyncActions } from 'store/actions/offers';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* updateState(action) {
  const {
    UpdateState: {
      Actions: { SUCCESS, FAILURE },
    },
  } = OffersAsyncActions;
  const {
    payload: { offerId, offerState },
  } = action;

  try {
    const response = yield call(apiCall, `/offers/${offerId}/${offerState}`, 'put');
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default updateState;
